/* eslint-disable no-console */
import React, { lazy, Suspense, useCallback, useEffect, useMemo, useState, useRef } from "react";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { initLogAnalytics, analysisLog } from "@/utils/logAnalytics";
import { FocusSDK as focusSDK, forceLogin, isFocusEnv, isLinuxOs, useDebounce } from "@/utils";
import { setGatewayInstance } from "@/server/gateway";
import logger from "@/utils/logger";
import { message } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import AppRuntimeEnv from "@/types/AppRuntimeEnv";
import { AuthData } from "@/types/LocalConfig";
import { connect } from "dvajs";
import cache from "@/utils/cache";
import ImService from "@/server/ImService";
import {
  ChatMessage,
  ChatMessageType,
  Employee,
  Session,
  SessionType,
  MessageRespType,
  EmployeeAttribute
} from "@/types/chat";
import HomePage from "@/pagesv2/NewHomePage";
import ThemeComp from "./components/ThemeComp";
import { initFileUploadService } from "@/server/FileService";
import Eventemitter3 from "eventemitter3";
import CloudLinkMeetingControl from "./components/MeetingCloudLink/MeetingControl";
import ChatState, { QuickReply } from "@/types/chat/State";
import Bus from "@/utils/bus";
import ConnectState from "@jd/jdee.im.sdk/lib/es/enum/ConnectState";
import { getWatermark } from "@/utils/ui";
import NotifyModal from "@/components/Modals/NotifyModal";
import { SuperviseType } from "@/types/supervise";
import user, { ICommonConfig, UserState } from "@/models/user";
import dayjs from "dayjs";
import { setMiniEOpenInstance } from "@/server/miniEOpen";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
import ErrorCatch from "./components/ErrorHolder/ErrorCatch";
import StartLoading from "./components/StartLoading";
import { permissionStatus } from "./notifications";
import notifyInfo from "@/assets/img/notify-info.png";
import closeImg from "@/assets/img/close.png";
import { UAParser } from "ua-parser-js";
import classNames from "classnames";
import { notifyMask } from "@/api/mask";
import { changeOpenUserid } from "@/api/miniEOpen";
import { takeTerminals } from "@/api/meeting";
import lifecycle from "page-lifecycle";
import {
  CloseMethod,
  KEY_PROMPT_VER,
  changeEgovUrl,
  getShowTipLocal,
  maskName
} from "@/utils/tools";
import aiNoticeCardService from "@/services/AINoticeCardService";
import DownloadFileQueue from "./utils/DownloadFileQueue";

import NetworkCheck, { setNavigatorOnline } from "./utils/NetworkCheck";
import config, { ConfigEnum, getNetCheckUrl } from "./config/config";
import getCurVoiceHandler from "./components/chat/handler/voiceHandler";
import { debounce } from "lodash";
import { getUserEbookDetailList } from "./api/ebook";
import { CloudLinkStatusEnum, getCloudLinkStatus } from "./components/MeetingCloudLink/Connector";
import { createCloudLinkCall } from "./components/MeetingCloudLink/utils";
import { handleCreateMeeting } from "./components/Meeting/utils";
import { mapUserDetailTarget } from "./components/BigScreen/common";
import { mapGetEbookDeptInfoList } from "./components/AddressBook/common";
// import * as Sentry from "@sentry/react";
import { EbookState } from "./models/ebook";
import { getBigScreenMeetingTopic, joinMeeting } from "./baseComponents/Meeting/utils";
import { AVSDK } from "./baseComponents/Meeting/common";
import InitJoySpaceController from "./components/Joyspace/controllers/InitJoySpaceController";
import SyncJoySpaceController from "./components/Joyspace/controllers/SyncJoySpaceController";
import { ScheduleDetailFrom } from "@/components/Calendars/Schedule/Detail";
import {
  getJoySpaceDucc,
  notUseJoySpaceOffline,
  setJoySpaceAI,
  setJoySpaceDucc
} from "./components/Joyspace/util";
import InitThirdAppService from "./components/ThirdApp/components/service/InitThirdAppService";
// import InitCardService from "./components/ThirdApp/components/service/InitCardService";
import { handleLinkClick } from "./components/chat/message/AINoticeCard/utils";
import Cookies from "js-cookie";
import globalDataInitFun from "@/utils/globalDataInitFun";
import { ClientConfigEnum } from "./config/clientConfig";
import { clientConfigRequest, queryClientConfig } from "./api/user";
import { getEmplFollow } from "./api/chat";
import { IClientConfig, ThirdAppSceneType } from "./types/common";
import { ApplyAuthorResourceToClientConfig } from "@/utils/envConfig";
import { isSameDay } from "./utils/date";
import { APP_NAME } from "./config/name";
import BaseService from "./attributes/BaseService";
import {
  handleCreateGroupMeeting,
  launchSession,
  removeFriend,
  startJrtc,
  startVoip
} from "./components/UserCard/common";
import { UserCardAction } from "@jd/focus-desktop-comps/lib/es/UserCard/UserCardType";
import useShareUserCard from "./components/Modals/useShareUserCard";
import { NetState } from "./models/netStatus";
import { isEqualEmployee, sleep } from "./utils/chat/message";

// import WinNotification from "@/pagesv2/WinNotification";
import ChatSupportPage from "@/pagesv2/ChatSupport";
// import WinUnreadPanel from "@/pagesv2/WinUnreadPanel";
import WebBrowserPage from "@/pagesv2/WebBrowserPage";
import UserCardPage from "@/pagesv2/UserCardPage";
import { settings } from "cluster";
import LoginModal from "@/components/LoginComp/LoginModal";
import { isLogin, userDataStore } from "./utils/user";

// const UserCardPage = lazy(() => import("@/pagesv2/UserCardPage"));
// const WinNotification = lazy(() =>
//   import(/* webpackChunkName: "WinNotification" */ "@/pagesv2/WinNotification")
// );
// const WinUnreadPanel = lazy(() =>
//   import(/* webpackChunkName: "WinUnreadPanel" */ "@/pagesv2/WinUnreadPanel")
// );
// const ChatSupportPage = lazy(() =>
//   import(/* webpackChunkName: "ChatSupportPage" */ "@/pagesv2/ChatSupport")
// );
// const WebBrowserPage = lazy(() =>
//   import(/* webpackChunkName: "WebBrowserPage" */ "@/pagesv2/WebBrowserPage")
// );

const { REACT_APP_DEBUG_PROD } = process.env;

const log = logger.getLogger("AppV2");
const suspenseLoading = () => (
  <div className="flex1 flex-center">
    <StartLoading />
  </div>
);

const localUrl = new URL(location.href);
const loadSess = localUrl.searchParams.get("loadSess"); // 1
const pageName = localUrl.searchParams.get("page");
const pageType = localUrl.searchParams.get("type");
const isHomePage = !pageName && !localUrl.pathname.includes("VideoViewer");
const isChatPage =
  pageName === "chat" &&
  (pageType === "g" || pageType === "s" || pageType === "n" || pageType === "mt");

const watermark = getWatermark({
  top: 80
});
const betaWatermark = getWatermark({
  id: "app_test_wm_el",
  color: "#8A8A8A",
  opacity: 0.3,
  fontSize: 32
});
const hiddenWatermark = getWatermark({
  color: "#000000",
  opacity: 0.005,
  fontSize: 12
});

const clearImServiceListeners = () => {
  const imService = ImService.getInstance();
  imService?.removeAllListeners("chat_new_message");
  imService?.removeAllListeners("chat_batch_message");
};
function AppContainer(props: any) {
  const {
    receiveSessionNewMessage,
    receiveSessionBatchMessage,
    receiveCustomAppConfigMessage,
    setUserData,
    getAllChatSessions,
    getCurrentEmployee,
    changePersonalTaskDraw,
    userData,
    setDetailDrawerVisible,
    currentEmployee,
    setMainWinShow,
    clearSessionStatusMap,
    updateBigScreenSelectedList,
    setRightDrawerVisible,
    selectUserList,
    setCurrentNetInfo,
    newContactsCount,
    setIsMessageModule,
    onUpdateAuthInfo,
    quickReplyVersion,
    setQuickReplyInfo,
    setCurrentNetOffline,
    connectState,
    onGlobalError,
    getNewContactsCount,
    loadAllSessionListEnd,
    updateSessionMessageMid,
    updateSessionMessagesTimestamp,
    updateFollowUserList,
    updateGlobalClientConfig,
    setCommonConfig,
    newPublicResult,
    logActive,
    setLogActive,
    deleteSessionMessages,
    allSessionList,
    updateCustomAppList,
    localConfigData,
    setPromptData,
    setThirdAppMsg,
    updatehirdAppList,
    queryTeamConfig,
    queryFuncInfoData,
    fetchAllAppList,
    fetchSceneAppList,
    getCustomNoticeSession,
    loadLocalConfig,
    commonConfig,
    teamConfig
  } = props;
  const [service, setService] = useState(props.service);
  const history = useHistory();
  const location = useLocation();
  const [canUseWithoutLogin, setCanUseWithoutLogin] = useState(true);
  const [authData, setAuthData] = useState<AuthData | null>(null);
  const authDataRef = useRef<AuthData | null>(null);
  const [imService, setImService] = useState<ImService | null>(null);
  const imserviceInited = useRef<boolean>(false);
  const appRuntimeEnv: AppRuntimeEnv = service.appRuntime;
  const [configLoaded, setConfigLoaded] = useState(false);
  const currentUserId = React.useRef<any>();
  const netCheckIdRef = useRef("");
  const selectListRef = useRef<any>([]);
  const isInitAIRef = useRef(false);
  const deeplinkSearchRef = React.useRef<string>("");
  const [notifyVisible, setNotifyVisible] = useState<any>(false);
  const [notifyStatus, setNotifyStatus] = useState<any>(
    window.Notification?.permission || "granted"
  );
  const [notifyDis, setNotifyDis] = useState(true);
  const [globalDataInitFlag, setGlobalDataInitFlag] = useState<any>({
    permissions: false,
    quickReplys: false
  });
  const [permissions, setPermissions] = useState<any>([]);
  const [clientConfig, setClientConfig] = useState<IClientConfig>({
    [ClientConfigEnum.JD_AUDIO]: 1
  });
  // @ts-ignore
  const [globalContext, setGlobalContext] = useState<GlobalContextConfig>({
    focusSDK,
    service,
    appRuntimeEnv: service.appRuntime,
    onGlobalError,
    isDesktop: isFocusEnv(),
    currentEmployee,
    notifyStatus: window.Notification?.permission || "granted",
    notifyDis: true,
    onLine: true,
    localConfigData,
    clientConfig: {
      [ClientConfigEnum.JD_AUDIO]: 1
    }
    // isWebpSupported: false,
  });
  const [waterMarkText, setWaterMarkText]: any = useState([]);
  const [hiddenWaterMarkText, setHiddenWaterMarkText]: any = useState();
  const loadedRef = useRef(false);
  const thirdAppKeysRef = useRef<string[]>([]);
  // 解决退出登录不刷新问题
  useEffect(() => {
    setGlobalContext((pre: GlobalContextConfig) => {
      return {
        ...pre,
        appRuntimeEnv: service.appRuntime
      };
    });
  }, [service.appRuntime]);
  const goToIndex = useCallback(() => {
    history.push("/homePage");
    console.log("goToIndex", "goToIndex");
  }, [history]);
  useEffect(() => {
    focusSDK.on("goToIndex", goToIndex);
    return () => {
      focusSDK.off("goToIndex", goToIndex);
    };
  }, [goToIndex, focusSDK]);
  // 仅网页端这里会有帮助地址、通知版本暂时写死
  const appVersion = "1.7.0";
  // const notifyRef = React.useRef<any>(null);
  // let helpUrl = "";
  // if (appRuntimeEnv.envConfig?.helpUrl) {
  //     helpUrl = appRuntimeEnv?.envConfig?.helpUrl;
  // } else {
  // const helpUrl = useMemo(() => {
  //   let currentOrigin = focusSDK.getMeMainEntry();
  //   let helpSrc = `${currentOrigin}/guide/#/pc?web=true&type=6`;
  //   if (process.env.REACT_APP_NODE_ENV !== "production") {
  //     helpSrc = `${currentOrigin}/jingzhiban#/pc?web=true&type=6`;
  //   }
  //   return helpSrc;
  // }, []);
  // }
  const getBrowserName = useMemo(() => {
    let parser = new UAParser();
    let browserName = parser.getBrowser().name;
    return browserName?.toLowerCase();
  }, []);

  const initFollow = useCallback(async () => {
    log.info("同步特别关注");
    const [data, err] = await getEmplFollow();
    if (err) {
      console.error(err);
      return;
    }
    data.forEach((user: any) => {
      ImService.getInstance().refreshBatch({
        pin: user.userId || "",
        teamId: user.teamId || "",
        app: user.appId || ""
      });
    });
    updateFollowUserList(data);
  }, [updateFollowUserList]);
  useEffect(() => {
    Bus.on("chat_message_multiSync_event:attentionSync", initFollow);
    return () => {
      Bus.off("chat_message_multiSync_event:attentionSync", initFollow);
    };
  }, [initFollow]);

  useEffect(() => {
    aiNoticeCardService.setImService(imService);
  }, [imService]);
  // 注册日程与im融合服务，监听解散组；

  // 初次通知遮罩弹出
  useEffect(() => {
    if (isFocusEnv()) {
      return;
    }
    const notifyMaskShow = async () => {
      if (window.Notification) {
        let status: NotificationPermission | string = Notification.permission;
        if (status === "default") {
          if (getBrowserName !== "firefox") {
            let res = await notifyMask({ appVersion });
            // 返回1 需要打开通知遮罩
            let canShowMask = !!res;
            if (canShowMask) {
              setNotifyVisible(true);
              // 获取通知授权
              let newStatus = await permissionStatus();
              // 授权为禁止或允许
              if (newStatus) {
                status = newStatus;
              }
              setNotifyVisible(false);
            }
          }
        }
        setGlobalContext((globalContext: any) => ({
          ...globalContext,
          notifyStatus: status
        }));
        setNotifyStatus(status);
      }
    };
    if (userData?.user?.realName) {
      notifyMaskShow();
    }
  }, [userData, getBrowserName]);

  useEffect(() => {
    if (!authData || loadedRef.current) return;
    loadedRef.current = true;
    service.focusService.commonConfig().then((res: ICommonConfig) => {
      setCommonConfig(res);
    });
  }, [service.focusService, authData]);

  // 打开通知
  const openNotify = useCallback(async (event) => {
    event.preventDefault();
    let res = await notifyMask({ appVersion });
    let canShowMask = !!res;
    if (canShowMask) {
      setNotifyVisible(true);
      let newStatus = await permissionStatus();
      if (newStatus) {
        setNotifyStatus(newStatus);
        setGlobalContext((globalContext: any) => ({
          ...globalContext,
          notifyStatus: newStatus
        }));
      }
      setNotifyVisible(false);
    } else {
      let newStatus = await permissionStatus();
      console.log("newStatus", newStatus);
      if (newStatus) {
        setNotifyStatus(newStatus);
        setGlobalContext((globalContext: any) => ({
          ...globalContext,
          notifyStatus: newStatus
        }));
      }
    }
  }, []);

  const imLogin = useCallback(
    async (authInfo: any, appRuntimeEnv: any, force: boolean) => {
      const imService = ImService.getInstance();
      if (!isHomePage || !imService) {
        return;
      }
      try {
        await imService.loginIm(
          {
            xToken: authInfo.accessToken,
            xTeamId: appRuntimeEnv.selectedTeamId,
            xClient: appRuntimeEnv.registryConfig.client
          },
          authInfo,
          force,
          isHomePage
        );
        console.log("connectState---", connectState);
        // 离线启动时，获取不到用户信息设置ws连接错误
        if (connectState === ConnectState.ERROR) {
          return;
        }
        if (imService) {
          if (!pageName || loadSess === "1") {
            // performance.mark('get-all-sessions-start');
            getAllChatSessions();
            getNewContactsCount();
          }
          // 首次加载个人信息保存到缓存里
          getCurrentEmployee(true);
        }
        imserviceInited.current = true;
        Bus.emit("chat:state", {
          state: ConnectState.READY
        });
        // const netServer = NetworkCheck.getInstance({
        //     url: getNetCheckUrl(),
        // });
        // netServer.stopCheck();
      } catch (e) {
        console.log("im--login error--", e);
      }
    },
    [connectState, getCurrentEmployee, getAllChatSessions, getNewContactsCount]
  );

  const initCustomAppList = useCallback(async () => {
    if (isInitAIRef.current) return;
    getCustomNoticeSession();
    queryFuncInfoData();
    getThirdAppList({
      service,
      useId: currentEmployee?.userId,
      teamId: currentEmployee?.teamId
    }).then((res: any) => {
      try {
        const thirdAppIds = Object.keys(res);
        const thirdApps: any[] = Object.values(res);
        thirdAppKeysRef.current = thirdApps.map((app) => app.applicationKey);
        if (thirdAppIds?.length) {
          // 237 获取应用脚标
          service.appStoreService
            .getAppMsgCount({
              applicationIds: thirdAppIds
            })
            .then((badgeRes: any) => {
              if (badgeRes?.records?.length) {
                const msgObj: any = {};
                badgeRes.records.forEach((resItem: any) => {
                  const appData = res[resItem.applicationId];
                  if (appData) {
                    // 237 修改角标结构，保存场景类型
                    msgObj[resItem.applicationId] = {
                      badge: resItem.badgeCount,
                      showBadge: appData.showBadge
                    };
                  }
                });
                setThirdAppMsg(msgObj);
              }
            });
        }
      } catch (e) {}
    });
    // 237 获取导航场景应用
    fetchSceneAppList({
      service,
      sceneType: ThirdAppSceneType.NAVBAR,
      callback: (res: any) => {
        queryTeamConfig({
          nav: appRuntimeEnv?.ui?.layout?.nav,
          settings: appRuntimeEnv?.registryConfig?.settings,
          thirdMap: res,
          localConfigData
        });
        const appValues = Object.values(res);
        const thirdAppIds = appValues.map((i: any) => i.applicationId);
        if (thirdAppIds?.length) {
          // 237 获取应用脚标
          service.appStoreService
            .getAppMsgCount({
              applicationIds: thirdAppIds
            })
            .then((badgeRes: any) => {
              if (badgeRes?.records?.length) {
                const msgObj: any = {};
                badgeRes.records.forEach((resItem: any) => {
                  const appDatas = appValues.filter(
                    (i: any) => i.applicationId === resItem.applicationId
                  );
                  if (appDatas?.length) {
                    appDatas.forEach((app: any) => {
                      if (!resItem.badgeCount) {
                        return;
                      }
                      // 237 修改角标结构，保存场景类型
                      msgObj[`${app.applicationId}_${app.sceneId}`] = {
                        applicationId: app.applicationId,
                        badge: resItem.badgeCount,
                        showBadge: app.showBadge
                      };
                    });
                  }
                });
                setThirdAppMsg(msgObj);
              }
            });
        }
      }
    });
    isInitAIRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    getCustomNoticeSession,
    fetchAllAppList,
    service,
    queryTeamConfig,
    currentEmployee,
    appRuntimeEnv?.ui?.layout?.nav,
    appRuntimeEnv?.registryConfig?.settings,
    localConfigData
  ]);

  useEffect(() => {
    if (
      !isInitAIRef.current &&
      loadAllSessionListEnd &&
      currentEmployee?.userId &&
      (isHomePage || isChatPage)
    ) {
      initCustomAppList();
    }
  }, [currentEmployee?.userId, initCustomAppList, loadAllSessionListEnd]);
  const doImLogin = useDebounce(imLogin, 1000);

  // 来新消息时增加消息通知
  const messageListener = useCallback(
    async (message: ChatMessage) => {
      if ((message as any).type === ChatMessageType.CUSTOM_APP_CONFIG_CHANGE) {
        receiveCustomAppConfigMessage(message);
      } else {
        if ((message as any)?.type === ChatMessageType.INVITE_REVOKE) {
          const imService1 = ImService.getInstance();
          let cEmployee = currentEmployee?.userId
            ? currentEmployee
            : await imService1.getCurrentEmployee();
          if (
            !isEqualEmployee(cEmployee as Employee, message.sender) &&
            message.forwardIdList?.length
          ) {
            deleteSessionMessages({
              sessionId: message.sessionId,
              forwardIdList: message.forwardIdList
            });
          }
        }
        receiveSessionNewMessage(message);
      }
    },
    [
      deleteSessionMessages,
      receiveSessionNewMessage,
      currentEmployee,
      receiveCustomAppConfigMessage
    ]
  );

  const messageBatchListener = useCallback(
    (messages: ChatMessage[]) => {
      receiveSessionBatchMessage(messages);
    },
    [receiveSessionBatchMessage]
  );

  const initImService = useCallback(
    (imService: ImService, authInfo: any, appRuntimeEnv: any) => {
      const isProd = REACT_APP_DEBUG_PROD === "false" ? true : false;
      focusSDK.printLog("initImService", `im start login ...${isProd}`);
      // 下一行，会清楚所有监听，不然会有多效监听效果
      imService?.removeAllListeners("chat_new_message");
      imService?.on("chat_new_message", messageListener);
      imService?.removeAllListeners("chat_batch_message");
      imService?.on("chat_batch_message", messageBatchListener);
      loadLocalConfig();
      doImLogin(authInfo, appRuntimeEnv, isProd);
    },
    [messageListener, messageBatchListener, loadLocalConfig, doImLogin]
  );
  const startImRelogin = useCallback(() => {
    const timer = setTimeout(() => {
      clearTimeout(timer);
      doImLogin(authDataRef.current, appRuntimeEnv, true);
      focusSDK.printLog("AppV2-retry-login-retry", "startImRelogin");
    }, 30 * 1000);
  }, [doImLogin, appRuntimeEnv]);
  const onAuthInfoLoad = useCallback(
    async (authInfo: AuthData, service) => {
      console.log("isLoginfalse3", service);
      userDataStore.isLogin = false;
      if (!authInfo) {
        log.debug("no authInfo, logout", { authInfo });
        focusSDK.printLog("no authInfo, logout", JSON.stringify(authInfo));
        setConfigLoaded(true);
        focusSDK.logout();

        return;
      }
      const appRuntimeEnv = service.appRuntime;
      if (!appRuntimeEnv) {
        log.debug("no appRuntimeEnv, logout", { authInfo, appRuntimeEnv });
        focusSDK.printLog("no appRuntimeEnv, logout", JSON.stringify({ authInfo, appRuntimeEnv }));
        focusSDK.logout();
        return;
      }
      log.debug("authtest:authInfo loaded", { authInfo });
      appRuntimeEnv.setAuthInfo(authInfo);
      await setUserData({
        user: {
          ...authInfo,
          team: authInfo.teamUserInfo
        },
        app: {
          appId: appRuntimeEnv.gateway.appId,
          deviceId: appRuntimeEnv.registryConfig.machineId,
          client: appRuntimeEnv.registryConfig.client
        }
      });
      setGlobalContext((globalContext: any) => {
        return {
          ...globalContext,
          service,
          appRuntimeEnv
        };
      });
      setAuthData(authInfo);
      authDataRef.current = authInfo;
      // 初始化操作日志分析埋点
      initLogAnalytics(authInfo.account, authInfo, focusSDK);
      onUpdateAuthInfo(authInfo);
      setGatewayInstance(appRuntimeEnv.gateway, authInfo, appRuntimeEnv);
      setMiniEOpenInstance(appRuntimeEnv.envConfig.open, authInfo, appRuntimeEnv);
      // merge token
      cache.token = {
        ...(cache.token || {}),
        token: {
          focusToken: authInfo.accessToken,
          focusClient: appRuntimeEnv.registryConfig.client,
          focusTeamId: appRuntimeEnv.selectedTeamId
        },
        deviceCode: appRuntimeEnv.registryConfig.machineId
      };
      cache.gateWayAppId = appRuntimeEnv.gatewayAppId;
      cache.ddAppId = authInfo.ddAppId;
      setAuthData(authInfo);
      // performance.mark('im-get-instance-start');
      const imService1 = ImService.getInstance(appRuntimeEnv);
      const netServerCurrent = NetworkCheck.getInstance({
        url: getNetCheckUrl()
      });
      const currentNavOnline = await netServerCurrent.checkNet();
      // performance.mark('im-get-instance-end');
      if (ImService.isValid() && (isLinuxOs() || currentNavOnline)) {
        initImService(imService1, authInfo, appRuntimeEnv);
      } else {
        Bus.emit("chat:state", {
          state: ConnectState.OFFLINE
        });
        const voiceHandler = getCurVoiceHandler();
        voiceHandler?.destroy();
      }
      setImService(imService1);
      await initFileUploadService(appRuntimeEnv, authInfo);
      const fn = async () => {
        if (!isHomePage && pageName !== "user-card" && !isChatPage) {
          return;
        }
        const res = await clientConfigRequest();
        if (res) {
          setClientConfig({
            ...res
          });
          //   setJoySpaceDucc({
          //     ...getJoySpaceDucc(),
          //     isLLMAI: (res.llmAI || 0) === 1 && isFocusEnv()
          //   });
          setJoySpaceAI((res.llmAI || 0) === 1 && isFocusEnv());
          updateGlobalClientConfig(res);
          ApplyAuthorResourceToClientConfig(res);
        }
        await globalDataInitFun({
          setQuickReplyInfo,
          setPermissions,
          setGlobalDataInitFlag,
          quickReplyVersion,
          contextGlobalDataInitFlag: globalDataInitFlag
        });
      };
      userDataStore.isLogin = true;
      fn();
      if (isHomePage) {
        try {
          // console.log('=======>');
          if (notUseJoySpaceOffline()) {
            return;
          }
          // 初始化数据库之前先设置userInfo
          BaseService.setUserInfo(authInfo);
          // 初始化数据库
          InitJoySpaceController.init();
          // 初始化工作台数据库
          InitThirdAppService.init();
          // 初始化工作台卡片数据库
          // InitCardService.init();
          // 同步数据
          SyncJoySpaceController.init();
        } catch (error) {
          console.log(error);
        }
        log.info("初始化特别关注");
        initFollow();
        if (isFocusEnv()) {
          if (localConfigData?.settings?.preLoadImageWin) {
            focusSDK.sendIpcMessage("image:presetImagePreviewWindow", {
              isOpen: false
            });
          }
          if (localConfigData?.settings?.preLoadCaptureWin) {
            focusSDK.sendIpcMessage("capture:presetCaptureWindows");
          }
        }
      }
    },
    [
      onUpdateAuthInfo,
      setUserData,
      initImService,
      setQuickReplyInfo,
      quickReplyVersion,
      globalDataInitFlag,
      updateGlobalClientConfig,
      initFollow,
      localConfigData?.settings?.preLoadImageWin,
      localConfigData?.settings?.preLoadCaptureWin
    ]
  );

  const onReLogin = useCallback(
    (d: AuthData) => {
      onAuthInfoLoad(d, service).then(() => {
        log.info("onReLogin finished.");
      });
    },
    [onAuthInfoLoad, service]
  );

  const doGetOffMessage = debounce(() => {
    imService?.getOfflineMessage();
  }, 100);

  const onAuthReady = useCallback(
    (data) => {
      if (data?.state === ConnectState.AUTHED) {
        doGetOffMessage();
        Bus.off("chat:state", onAuthReady);
      }
      if (data?.state === ConnectState.CONNECTED) {
        if (newContactsCount > 0) {
          // 断网重连 新的申请存在未读数时 有可能移动端已读，桌面端需要重新获取新的申请数量 保持数量多端同步
          imService?.updateNewContactCount();
        }
      }
    },
    [doGetOffMessage, imService, newContactsCount]
  );

  const onlineListener = useCallback(() => {
    setCurrentNetOffline(false);
    // 如果未登录不需要重新初始化
    if (!isLogin()) return;
    focusSDK.printLog("onlineCallback", `online: ${navigator.onLine}`);
    // if (navigator.onLine) {
    Bus.emit("chat:state", {
      state: ConnectState.CONNECTING
    });
    if (imserviceInited.current) {
      const imService = ImService.getInstance();
      Bus.off("chat:state", onAuthReady).on("chat:state", onAuthReady);
      imService?.reloginIm({
        xToken: authDataRef.current?.accessToken
      });
    } else {
      const imService1 = ImService.getInstance(appRuntimeEnv);
      initImService(imService1, authDataRef.current, appRuntimeEnv);
    }
    const fn = async () => {
      if (!isHomePage && !isChatPage) {
        return;
      }
      const res = await clientConfigRequest();
      if (res) {
        setClientConfig({
          ...res
        });
        // setJoySpaceDucc({
        //   ...getJoySpaceDucc(),
        //   isLLMAI: (res.llmAI || 0) === 1 && isFocusEnv()
        // });
        setJoySpaceAI((res.llmAI || 0) === 1 && isFocusEnv());
        updateGlobalClientConfig(res);
        ApplyAuthorResourceToClientConfig(res);
      }
      await globalDataInitFun({
        setQuickReplyInfo,
        setPermissions,
        setGlobalDataInitFlag,
        quickReplyVersion,
        contextGlobalDataInitFlag: globalDataInitFlag
      });
    };
    // 联网之后重新执行全局数据初始化
    fn();
    // }
  }, [
    appRuntimeEnv,
    initImService,
    onAuthReady,
    setQuickReplyInfo,
    quickReplyVersion,
    globalDataInitFlag,
    setPermissions,
    setCurrentNetOffline,
    updateGlobalClientConfig
  ]);

  const offlineListener = useCallback(async () => {
    if (!navigator.onLine) {
      ImService.getInstance()?.closeWS();
    }
    // 重新定义连接状态
    const netServer = NetworkCheck.getInstance({
      url: getNetCheckUrl()
    });
    setCurrentNetOffline(true);
    focusSDK.printLog("offlineCallback", `online: ${navigator.onLine}`);
    Bus.emit("chat:state", {
      state: ConnectState.OFFLINE
    });
    if (!navigator.onLine) {
      const voiceHandler = getCurVoiceHandler();
      voiceHandler?.destroy();
      // 清空下载队列
      DownloadFileQueue.getInstance()?.clearQueue();
    } else {
      // 由于im自动重连可能间隔过长，通过http判断网络状态
      if (!netServer.isStartCheck()) {
        netServer?.startCheck();
      }
    }
  }, [setCurrentNetOffline]);

  const onMainWinResume = useCallback(() => {
    const netServer = NetworkCheck.getInstance({
      url: getNetCheckUrl()
    });
    focusSDK.printLog("AppV2--on win resume");
    // if (!netServer.isStartCheck()) {
    //   netServer?.startCheck();
    // }
    netServer.getState();
  }, []);

  const onMainWinHidden = useCallback(() => {
    setMainWinShow({ show: false });
  }, [setMainWinShow]);
  const onMainWinShow = useCallback(
    (data: any) => {
      if (data?.type === "focus") {
        if (imService) {
          if (!logActive) {
            reportWindowFocusLog().then(() => {
              setLogActive(true);
            });
          }
        }
      } else {
        setMainWinShow({ show: true });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setMainWinShow, imService, logActive, setLogActive]
  );

  const onForceLogout = useCallback(() => {
    if (!forceLogin) {
      focusSDK.logout("expired");
      return;
    }
    console.log("onForceLogout");
    // tj: logout 托盘停止闪动
    focusSDK.sendIpcMessage("flashSession", { type: "stop" });
    if (ImService.getInstance()) {
      ImService.getInstance().logoutIm().then();
    }
    // 清空下载队列
    DownloadFileQueue.getInstance()?.clearQueue();
    const netServer = NetworkCheck.getInstance({
      url: getNetCheckUrl()
    });
    netServer?.off("online", onlineListener);
    netServer?.off("offline", offlineListener);
    netServer?.stopCheck();
    deeplinkSearchRef.current = "";
    thirdAppKeysRef.current = [];
    clearImServiceListeners();
    if (isFocusEnv()) {
      focusSDK.setAppBadgeCount(0);
    }
    imserviceInited.current = false;
    isInitAIRef.current = false;
  }, [onlineListener, offlineListener]);

  const onImLogout = useCallback(() => {
    imserviceInited.current = false;
    isInitAIRef.current = false;
  }, []);

  const getThirdAppList = async (props: any) => {
    return new Promise((resolve) => {
      fetchAllAppList({
        service: props?.service,
        useId: props?.userId,
        teamId: currentEmployee?.teamId,
        // 获取
        callback: (res: any) => {
          console.log("tj:>[AppContainer]>getThirdAppList>>>>", res);
          resolve(res);
        }
      });
    });
  };

  const handleDeeplinkParams = useCallback(
    // eslint-disable-next-line complexity
    async (currentEmployee: any) => {
      const url = deeplinkSearchRef.current;
      const params = new URLSearchParams(url);
      console.log("tj:>>>handleDeeplinkParams111>>url", url, params);
      try {
        if (params) {
          const mparam = params.get("mparam");
          console.log("tj:>>>handleDeeplinkParams222>>", mparam);
          let users: any = [];
          const userId = params.get("userid")?.split(",");
          const terminalId = params.get("terminals")?.split(",") || [];
          const teamToken = params.get("token");
          if (userId && teamToken) {
            const [data] = await changeOpenUserid({
              data: { openUserIds: userId },
              headers: {
                Authorization: `Bearer ${teamToken}`,
                "content-type": "application/json"
              },
              method: "post"
            });
            if (data?.data) {
              users = await getUserEbookDetailList(
                data.data
                  .filter((item: any) => !!item.userId)
                  .map((item: any) => {
                    return {
                      userId: item.userId,
                      appId: currentEmployee.appId || currentEmployee.app,
                      teamId: currentEmployee.teamId
                    };
                  })
              );
            }
          }
          let mparamParams: any = {};
          let openPath = params.get("open");
          console.log("tj:>>>handleDeeplinkParams33333>", openPath);
          if (!openPath && mparam) {
            try {
              mparamParams = JSON.parse(mparam);
              openPath = mparamParams?.open;
            } catch (e) {}
          }
          console.log("tj:>>>handleDeeplinkParams444>", mparamParams);
          let meetingType = parseInt(params.get("meetingType") || "1", 10);
          meetingType = isNaN(meetingType) ? 1 : meetingType;
          let command = parseInt(params.get("command") || "0", 10);
          command = isNaN(command) ? 0 : command;
          console.log(
            `deeplink:---changeOpenUserid---res-openPath:${openPath}-command:${command}`,
            users,
            terminalId
          );

          let appkey = mparamParams?.appkey;
          console.log("tj:>>>handleDeeplinkParams555>>appkey>>openPath>", appkey, openPath);
          if (openPath?.includes("cloudlink")) {
            let toPath =
              command === 1 ? "address_list" : meetingType === 1 ? "cloudlink" : "meeting";
            if (!openPath.includes("meeting")) {
              toPath += "?create=1";
              if (history.location.pathname.includes("cloudlink")) {
                Bus.emit(`${toPath}:create-show`);
              }
              history.push(`/${toPath}`);
              return;
            }
            history.push(`/${toPath}`);
            // 入会
            if (users?.length || terminalId) {
              const toUsers = users?.map((item: any) => {
                const avatar = item?.fields?.find((i: any) => i.key === "avatar");
                const name = item?.fields?.find((i: any) => i.key === "name");
                return {
                  userId: item.userId,
                  teamId: item.teamId,
                  appId: item.appId,
                  userName: name?.val || "",
                  headImg: avatar?.val || ""
                };
              });

              // 是否在会
              const multi = params.get("multi");
              const handleInMeeting = () => {
                console.log(`deeplink:---handleInMeeting---multi:${multi}-command:${command}`);
                if (multi || command === 1) {
                  history.push("/address_list");
                } else {
                  focusSDK.setWindowFrame("min");
                }
              };
              if (meetingType === 0) {
                Bus.once("chat_in_meeting_invite", handleInMeeting);
              } else if (getCloudLinkStatus() === CloudLinkStatusEnum.IN_MEETING) {
                handleInMeeting();
              }
              if (meetingType === 1) {
                createCloudLinkCall({
                  toUsers,
                  terminals: {
                    terminalId
                  },
                  opts: {
                    meetingTopic: getBigScreenMeetingTopic()
                  }
                }).catch((err: any) => {
                  message.error(err.message || err || "会议创建失败");
                });
              } else {
                handleCreateMeeting(toUsers, getBigScreenMeetingTopic()).catch((err: any) => {
                  message.error(err.message || err || "会议创建失败");
                });
              }
            }
          } else if (openPath?.includes("meeting")) {
            const meetingId = params.get("meetingId");
            const sdkType = params.get("sdkType") as AVSDK;
            if (!meetingId || !sdkType) {
              return;
            }
            if (!Object.values(AVSDK).includes(sdkType)) {
              logger.error("未知的sdkType");
              return;
            }
            const avsdk = sdkType as AVSDK;

            joinMeeting(avsdk, {
              meetingNumber: meetingId,
              meetingPassword: params.get("password") || ""
            });
          } else if (openPath === "commandscreen") {
            let select = parseInt(params.get("select") || "1", 10);
            select = isNaN(select) ? 1 : select;
            let commonContact = parseInt(params.get("commonContact") || "0", 10);
            commonContact = isNaN(select) ? 0 : commonContact;
            console.log(`deeplink:----select:${select}--commonContact:${commonContact}-`);
            history.push("/address_list");
            setRightDrawerVisible(commonContact === 1 ? true : false);
            if (!users?.length && !terminalId?.length) {
              if (select === 0) {
                // 清空
                updateBigScreenSelectedList([]);
              }
              deeplinkSearchRef.current = "";
              return;
            }
            console.log("deeplink:----users---", users, terminalId);
            let devices = [];
            if (terminalId.length) {
              const [res] = await takeTerminals(1, 100);
              if (res?.recordList) {
                console.log("deeplink:--terminalId----", res);
                const list = res?.recordList.filter((item: any) => {
                  return terminalId.includes(item.terminalId);
                });
                devices = terminalId?.length ? mapUserDetailTarget(list, currentEmployee) : [];
              }
            }
            users = (users || [])
              .map((item: any) => {
                return {
                  ...item,
                  memberType: 1
                };
              })
              .concat(
                devices.map((item: any) => {
                  return {
                    ...item,
                    memberType: 2
                  };
                })
              );
            const ids = users.map((i: any) => i.userId);
            const groupData: any = await mapGetEbookDeptInfoList(ids);
            if (groupData?.length) {
              users = users.map((item: any, idx: number) => {
                if (groupData[idx]) {
                  item.groupList = groupData[idx]?.groupList;
                }

                return item;
              });
            }
            const rest = selectListRef.current.filter((item: any) => !ids.includes(item.userId));
            if (select === 1) {
              console.log("deeplink:--other--users---", users, rest);
              updateBigScreenSelectedList([...users, ...rest]);
            } else {
              console.log("deeplink:--rest--users---", rest);
              updateBigScreenSelectedList(rest);
            }
          } else if (openPath === "schedule") {
            history.push("/calendar");
          } else if (openPath === "thirdapp" && appkey) {
            console.log(
              "tj:>>>handleDeeplinkParams6666>>appkey>>openPath>",
              thirdAppKeysRef.current
            );
            // 三方应用
            history.push("/third_apps");
            // 获取可见应用
            let appInfo: any;
            if (thirdAppKeysRef.current?.length) {
              if (!thirdAppKeysRef.current.includes(appkey)) {
                return false;
              }
              appInfo = await service.appStoreService.getApplication({
                applicationKey: appkey
              });
              if (!appInfo?.application) {
                return false;
              }
              Bus.emit("openThirdApp", appInfo?.application);
            } else {
              const list: any = await getThirdAppList({
                service,
                userId: currentEmployee.userId,
                teamId: currentEmployee.teamId
              });
              console.log(
                "tj:>>>handleDeeplinkParams7777>>appkey>>openPath>",
                thirdAppKeysRef.current
              );
              const appList: any[] = Object.values(list);
              console.log("tj:>>>handleDeeplinkParams888>>appkey>>openPath>", appList);
              const hasApp = !!appList?.find((i) => i.applicationKey === appkey);
              console.log("tj:>>>handleDeeplinkParams99999>", hasApp);
              if (!hasApp) {
                return false;
              }
              appInfo = await service.appStoreService.getApplication({
                applicationKey: appkey
              });
              if (!appInfo?.application) {
                return false;
              }
              Bus.emit("openThirdApp", appInfo?.application);
            }
          }
        }
      } catch (e) {
        console.log("handle deeplink error: ", e);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history]
  );

  const onMainWinOpen = useCallback(
    (data: any) => {
      if (data?.urlSearch) {
        deeplinkSearchRef.current = data.urlSearch;
        if (currentEmployee?.userId) {
          console.log(
            "tj:>>>>onMainWinOpen>>>handleDeeplinkParams2222>",
            deeplinkSearchRef.current
          );
          handleDeeplinkParams(currentEmployee);
        }
      }
      deeplinkSearchRef.current = "";
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentEmployee]
  );

  useEffect(() => {
    if (!deeplinkSearchRef.current || !currentEmployee.userId) {
      return;
    }
    console.log("tj:>>>>>>>handleDeeplinkParams1111>", deeplinkSearchRef.current);
    handleDeeplinkParams(currentEmployee);
    deeplinkSearchRef.current = "";
  }, [currentEmployee, handleDeeplinkParams]);

  useEffect(() => {
    selectListRef.current = selectUserList;
  }, [selectUserList]);
  useEffect(() => {
    const netServer = NetworkCheck.getInstance({
      url: getNetCheckUrl()
    });
    const setOnlineStatus = (isOnline: boolean) => {
      setGlobalContext((globalContext: any) => ({
        ...globalContext,
        onLine: isOnline
      }));
      if (isHomePage && isFocusEnv()) {
        focusSDK.sendGlobalWebviewMessage("onlineOfflineCheck", {
          isOnline
        });
      }
    };
    netServer?.off("online-event", setOnlineStatus);
    netServer?.off("offline-event", setOnlineStatus);
    netServer?.on("online-event", setOnlineStatus);
    netServer?.on("offline-event", setOnlineStatus);
    return () => {
      netServer?.off("online-event", setOnlineStatus);
      netServer?.off("offline-event", setOnlineStatus);
    };
  }, []);
  const supportsWebp = useCallback(({ createImageBitmap, Image }: any) => {
    if (!createImageBitmap || !Image) return Promise.resolve(false);

    return new Promise((resolve) => {
      const image = new Image();
      image.onload = () => {
        createImageBitmap(image)
          .then(() => {
            resolve(true);
          })
          .catch(() => {
            resolve(false);
          });
      };
      image.onerror = () => {
        resolve(false);
      };
      image.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=";
    });
  }, []);

  const webpIsSupported = useCallback(() => {
    let memo: any = null;
    return () => {
      if (!memo) {
        memo = supportsWebp(window);
      }
      return memo;
    };
  }, [supportsWebp]);

  useEffect(() => {
    if (!isHomePage) {
      return;
    }
    const netServer = NetworkCheck.getInstance({
      url: getNetCheckUrl()
    });
    if (netServer) {
      netCheckIdRef.current = netServer.getId();
    }
    if (!netServer?.isStartCheck()) {
      netServer?.startCheck();
    }
    return () => {
      netServer?.stopCheck();
    };
  }, []);

  const upateNetResult = useCallback(
    (data: any) => {
      const netServer = NetworkCheck.getInstance({
        url: getNetCheckUrl()
      });
      netServer.upadteNetResult({
        time: data.ct,
        state: data.state === "success" ? 1 : 0
      });
      if (data.state === "success" && connectState && connectState !== ConnectState.READY) {
        Bus.emit("chat:state", {
          state: ConnectState.READY
        });
      }
    },
    [connectState]
  );
  const onLogout = useCallback(() => {
    if (config[ConfigEnum.LEFT_SIDE_PAGE_INDEX]) {
      focusSDK.emit("goToIndex");
    }
    console.log("isLoginfalse2");
    userDataStore.isLogin = false;
    thirdAppKeysRef.current = [];
    setTimeout(() => {
      setAuthData(null);
    }, 0);
  }, []);
  useEffect(() => {
    focusSDK.off("logout", onLogout).on("logout", onLogout);
    return () => {
      focusSDK.off("logout", onLogout);
    };
  }, [onLogout]);
  useEffect(() => {
    if (!isHomePage) {
      return;
    }
    const netServer = NetworkCheck.getInstance({
      url: getNetCheckUrl()
    });
    netServer?.off("online", onlineListener);
    netServer?.off("offline", offlineListener);
    netServer?.on("online", onlineListener);
    netServer?.on("offline", offlineListener);
    Bus.off("chat:state-auth-faild", startImRelogin);
    Bus.on("chat:state-auth-faild", startImRelogin);
    Bus.off("chat:im-logout", onImLogout).on("chat:im-logout", onImLogout);
    return () => {
      netServer?.off("online", onlineListener);
      netServer?.off("offline", offlineListener);
      Bus.off("chat:state-auth-faild", startImRelogin);
      Bus.off("chat:im-logout", onImLogout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isHomePage) {
      return;
    }
    // if (!netCheckIdRef.current) {
    //     return;
    // }
    Bus.off("chat:force_quit", onForceLogout).on("chat:force_quit", onForceLogout);
    focusSDK.on("main-win-resume", onMainWinResume);
    focusSDK.on("main-win-hidden", onMainWinHidden);
    focusSDK.on("main-win-show", onMainWinShow);
    focusSDK.on("onlineOfflineCheck", (data) => {
      focusSDK.printLog("onlineOfflineCheck", data);
    });
    const imStateType = "ack";
    Bus.on(`chat:extState:${imStateType}`, upateNetResult);
    return () => {
      focusSDK.off("main-win-resume", onMainWinResume);
      focusSDK.off("main-win-hidden", onMainWinHidden);
      focusSDK.off("main-win-show", onMainWinShow);
      focusSDK.off("onlineOfflineCheck", (data) => {
        console.log("onlineOfflineCheck", data);
      });
      Bus.off("chat:force_quit", onForceLogout);
      Bus.off(`chat:extState:${imStateType}`);
    };
  }, [onMainWinResume, onMainWinHidden, onMainWinShow, onForceLogout, upateNetResult]);

  useEffect(() => {
    if (!isHomePage) {
      return;
    }
    focusSDK.off("main-page-open", onMainWinOpen).on("main-page-open", onMainWinOpen);
    return () => {
      focusSDK.off("main-page-open", onMainWinOpen);
    };
  }, [onMainWinOpen]);

  const [dateTime, setDateTime] = useState(dayjs().format("YYYYMMDD"));
  useEffect(() => {
    let timmer = setInterval(function () {
      setDateTime(dayjs().format("YYYYMMDD"));
    }, 24 * 60 * 60 * 1000);
    return () => {
      clearInterval(timmer);
    };
  }, []);
  useEffect(() => {
    if (userData?.user?.realName) {
      currentUserId.current = userData.user.userId;
      // console.log('currentUserId.current', currentUserId.current, userData.user);
      const mobile = userData.user.mobile;
      // 姓名+手机后四位 +20210314+非涉密网络
      let text = [
        userData.user.realName,
        mobile?.substring(mobile.length - 4, mobile.length),
        dateTime,
        "非涉密网络"
      ];
      if (process.env.REACT_APP_HIDE_WATERMARK === "true") {
        text = [];
      }
      let betaWatermarkText = process.env.REACT_APP_BETA_WATERMARK === "true" ? ["测试Beta包"] : [];
      watermark.setWaterMark([text.join(" ")]);
      hiddenWatermark.setWaterMark(text);
      setWaterMarkText([text.join(" ")]);
      setHiddenWaterMarkText(text);
      betaWatermark.setWaterMark(betaWatermarkText);
      try {
        const maskMobile = `${(mobile || "").substr(0, 3)}****${(mobile || "").substr(-4, 4)}`;
        // Sentry.configureScope(function (scope) {
        //   let user = {
        //     username: maskName(userData.user.realName),
        //     mobile: maskMobile,
        //     id: maskMobile,
        //     userId: userData.user.userId
        //   };
        //   let machineId = appRuntimeEnv.registryConfig.machineId;
        //   console.log("machineId", machineId);
        //   if (machineId) {
        //     (user as any).machineId = machineId;
        //   }
        //   scope.setUser(user);
        //   scope.setTag("custom-runtime", appRuntimeEnv.runtimeConfig?.key || "");
        // });
      } catch (e) {
        console.log(e);
      }
    }

    return () => {
      watermark.removeWatermark();
      hiddenWatermark.removeWatermark();
      betaWatermark.removeWatermark();
      setWaterMarkText([]);
      setHiddenWaterMarkText([]);
    };
  }, [userData, dateTime, appRuntimeEnv]);
  const init = useCallback((service) => {
    if (!service) {
      return;
    }

    // performance.mark('get-auth-info-start');
    const ts = Date.now();
    focusSDK.getAuthInfo((authInfo) => {
      console.log("isLoginfalse1");
      userDataStore.isLogin = false;
      if (!authInfo) {
        setConfigLoaded(true);
        return;
      }
      // 设置为团队的真实姓名
      authInfo.realName = authInfo.teamUserInfo?.realName || authInfo.realName || "";
      authInfo.headImg = authInfo.teamUserInfo?.headImg || authInfo.headImg || "";
      onAuthInfoLoad(authInfo, service).then(() => {
        log.info("getAuthInfo", Date.now() - ts);
        // 添加浏览器是否支持webp格式判断
        webpIsSupported()()
          // eslint-disable-next-line max-nested-callbacks
          .then((res: any) => {
            // console.log('是否支持 webp', res);
            setGlobalContext((globalContext: any) => {
              return {
                ...globalContext,
                isWebpSupported: res,
                isHomePage
              };
            });
            setConfigLoaded(true);
          })
          // eslint-disable-next-line max-nested-callbacks
          .catch((err: any) => {
            message.error(err);
            console.log(err);
          });
      });
      if (isHomePage) {
        clearSessionStatusMap();
      }
    });
  }, []);
  useEffect(() => {
    setService(service);
    init(service);
    focusSDK.on("appContainerReload", init);
    return () => {
      focusSDK.off("appContainerReload", init);
    };
  }, [init]);

  const onShowSuperviseDetail = useCallback(
    (data: any) => {
      const { superviseId } = data;
      setDetailDrawerVisible(false, superviseId);
      setTimeout(() => {
        setDetailDrawerVisible(true, superviseId);
      }, 300);
    },
    [setDetailDrawerVisible]
  );

  const shareUserCard = useShareUserCard({
    userData,
    currentEmployee,
    imService1: imService || null
  });
  const [voipClick, SetVoipClick] = useState(false);

  const onUserCardMessage = useCallback(
    async ({ data, type }) => {
      switch (type) {
        case UserCardAction.Chat:
          launchSession({ ...data, app: data.appId, pin: data.userId }, location, history);
          Bus.emit("onHideGlobalSearch");
          return;
        case UserCardAction.Voip:
          if (voipClick) {
            return;
          }
          SetVoipClick(true);
          setTimeout(() => {
            SetVoipClick(false);
          }, 5000);
          if (clientConfig[ClientConfigEnum.JD_AUDIO]) {
            startJrtc(data, currentEmployee, "voice");
            return;
          }
          // startVoip(data, currentEmployee);
          handleCreateGroupMeeting(data, currentEmployee, newPublicResult);
          return;
        case UserCardAction.Jrtc:
          startJrtc(data, currentEmployee);
          Bus.emit("onHideGlobalSearch");
          return;
        case UserCardAction.Meeting:
          console.log("Meeting---");
          handleCreateGroupMeeting(data, currentEmployee, newPublicResult);
          Bus.emit("onHideGlobalSearch");
          return;
        case UserCardAction.Share:
          return await shareUserCard(data as any);
        case "showEmplFollowList":
          history.push({
            pathname: "/systemSetting",
            state: {
              activeKey: "NotifySetting",
              showEmplFollowList: true
            }
          });
          return;
        case "showDepartment":
          if (history.location.pathname === "/address_list") {
            Bus.emit("navigateDepartmentTab", {
              deptInfo: data
            });
          } else {
            history.push({
              pathname: "/address_list",
              state: {
                deptInfo: data
              }
            });
          }
          return;
        case UserCardAction.Deleted:
          await removeFriend(data, currentEmployee);
          return;
      }
    },
    [clientConfig, currentEmployee, history, location, newPublicResult, shareUserCard, voipClick]
  );
  const onShowCalendarDetail = useCallback((data: any) => {
    const { deepLink } = data;
    DeeplinkEvent.open(deepLink, { from: ScheduleDetailFrom.WinNoticeCard });
  }, []);
  const onShowSysNoticeDetail = useCallback((data: any) => {
    const { deepLink } = data;
    handleLinkClick(deepLink || "");
  }, []);
  const onShowTaskDetail = useCallback(
    (data: any) => {
      const { taskId } = data;
      changePersonalTaskDraw(taskId, true, true);
    },
    [changePersonalTaskDraw]
  );

  const onSuperviseRead = useCallback(() => {
    Bus.emit("supervise/update");
  }, []);

  const KEY_WIN_FOCUS_VER = "win_focus_ver";

  async function reportWindowFocusLog() {
    let flag = false;
    try {
      const data = await ImService.getInstance()?.getAppModuleVersion(KEY_WIN_FOCUS_VER);
      if (!data) {
        // 发送埋点
        flag = true;
        analysisLog("xtbg_pc_data", "ACTIVE");
      }
      const res = JSON.parse(data);
      if (!res?.date || !isSameDay(parseInt(res.date, 10), new Date().getTime())) {
        // 发送埋点
        flag = true;
        analysisLog("xtbg_pc_data", "ACTIVE");
      }
    } catch (e) {}
    if (flag) {
      const date = new Date().getTime();
      ImService.getInstance()?.setAppVersion(
        JSON.stringify({
          date
        }),
        KEY_WIN_FOCUS_VER
      );
    }
    return flag;
  }

  const stateChange = useCallback(
    (event) => {
      if (isFocusEnv()) {
        return;
      }
      let newState = event.newState;
      if (newState === "active" || newState === "passive") {
        setMainWinShow({ show: true });
      } else {
        setMainWinShow({ show: false });
      }
    },
    [setMainWinShow]
  );

  const zoomNetResult = useCallback(
    ({ type, isPrivateNet, publicResult, privateResult }) => {
      console.log(
        `zoomNetResult: type, ${type}, publicResult, ${publicResult}, privateResult, ${privateResult}`
      );
      if (type === "zoomNet" || type === "netSetting") {
        setCurrentNetInfo({
          newPublicResult: publicResult,
          newPrivateResult: privateResult
        });
      }
    },
    [setCurrentNetInfo]
  );
  const updateSessionMessageMap = useCallback(
    async (data) => {
      await updateSessionMessageMid(data);
      await updateSessionMessagesTimestamp({
        timestamp: new Date().getTime()
      });
    },
    [updateSessionMessageMid, updateSessionMessagesTimestamp]
  );
  useEffect(() => {
    focusSDK.on("supervise:handleShowDetail", onShowSuperviseDetail);
    focusSDK.on("calendar:handleShowDetail", onShowCalendarDetail);
    focusSDK.on("sysNotice:handleShowDetail", onShowSysNoticeDetail);
    focusSDK.on("task:handleShowDetail", onShowTaskDetail);
    focusSDK.on("supervise:handleRead", onSuperviseRead);
    focusSDK.on("zoomNetResult:reply", zoomNetResult);
    // 网络连接切换时更新当前网络检测值
    focusSDK.on("netSettingResult:reply", zoomNetResult);
    lifecycle.addEventListener("statechange", stateChange);
    focusSDK.on("image:viewOriginal", updateSessionMessageMap);
    focusSDK.on("UserCardMessage", onUserCardMessage);

    return () => {
      focusSDK.off("supervise:handleShowDetail", onShowSuperviseDetail);
      focusSDK.off("calendar:handleShowDetail", onShowCalendarDetail);
      focusSDK.off("sysNotice:handleShowDetail", onShowSysNoticeDetail);
      focusSDK.off("task:handleShowDetail", onShowTaskDetail);
      focusSDK.off("supervise:handleRead", onSuperviseRead);
      focusSDK.off("zoomNetResult:reply", zoomNetResult);
      focusSDK.off("netSettingResult:reply", zoomNetResult);
      lifecycle.removeEventListener("statechange", stateChange);
      focusSDK.off("image:viewOriginal", updateSessionMessageMap);
      focusSDK.off("UserCardMessage", onUserCardMessage);
    };
  }, [
    onShowSuperviseDetail,
    onShowCalendarDetail,
    onShowSysNoticeDetail,
    onSuperviseRead,
    onShowTaskDetail,
    stateChange,
    zoomNetResult,
    updateSessionMessageMap,
    onUserCardMessage
  ]);

  const wsOnlineChangeEvent = useCallback(
    (data) => {
      if (!isHomePage) {
        return;
      }
      const { state } = data;
      console.log("--ws网络状态变化触发---", data);
      const netServer = NetworkCheck.getInstance({
        url: getNetCheckUrl()
      });
      if (
        state === ConnectState.CLOSED ||
        state === ConnectState.ERROR ||
        state === ConnectState.OFFLINE
      ) {
        if (!netServer.isStartCheck()) {
          netServer.resetStartState();
          netServer.startCheck();
        }
        if (state === ConnectState.OFFLINE) {
          setCurrentNetOffline(true);
        }
      } else if (state === ConnectState.READY) {
        setNavigatorOnline(true);
        setCurrentNetOffline(false);
        netServer.stopCheck();
      }
    },
    [setCurrentNetOffline]
  );

  useEffect(() => {
    Bus.on("chat:state", wsOnlineChangeEvent);
    // focusSDK.on('wsOnlineChange', wsOnlineChangeEvent);
    return () => {
      Bus.off("chat:state", wsOnlineChangeEvent);
    };
  }, [wsOnlineChangeEvent]);

  useEffect(() => {
    // console.log('location.pathname', location.pathname);
    if (location.pathname?.startsWith("/messages")) {
      setIsMessageModule(true);
    } else {
      setIsMessageModule(false);
    }
  }, [location.pathname, setIsMessageModule]);
  useEffect(() => {
    if (!isHomePage) {
      return;
    }
    try {
      let config = JSON.parse(focusSDK.getConfigData());
      const { settings } = config;
      const { egovFirst } = settings || {};
      let egovFirstValue = true;
      if (egovFirst === false) {
        egovFirstValue = false;
      }
      analysisLog(
        "xtbg_pc_system_setting_1687846673288",
        "7",
        JSON.stringify({ state: egovFirstValue ? "on" : "off" })
      );
    } catch (e) {
      console.error("getConfigData err", e);
    }
  }, []);

  const pageComp = useMemo(() => {
    cache.clientMode = "client";
    switch (pageName) {
      case "user-card":
        return <UserCardPage />;
      case "builtin-browser":
        return <WebBrowserPage />;
      case "chat":
        return <ChatSupportPage />;
      case "cloudlink-meeting-control":
        return <CloudLinkMeetingControl />;
      default:
        cache.clientMode = "server";
        return <HomePage />;
    }
  }, []);

  if (
    (isHomePage && !authData) ||
    (!(isHomePage || pageName === "builtin-browser") && (!configLoaded || !authData || !imService))
  ) {
    return (
      <div className="flex1 flex-center">
        {/* <Loading /> */}
        <StartLoading />
      </div>
    );
  }
  const browserNotifyTag = Cookies.get("openBrowserMsgNotify");
  return (
    <Suspense fallback={suspenseLoading()}>
      <GlobalContext.Provider
        value={{
          ...globalContext,
          localConfigData,
          authInfo: authData,
          imService,
          onReLogin,
          onGlobalError,
          setAuthInfo: setAuthData,
          events3: new Eventemitter3(),
          permissions: permissions,
          currentEmployee,
          globalDataInitFlag: globalDataInitFlag,
          setPermissions,
          setGlobalDataInitFlag,
          clientConfig: clientConfig,
          waterMarkText: waterMarkText,
          hiddenWaterMarkText: hiddenWaterMarkText,
          commonConfig,
          teamConfig
        }}
      >
        <ErrorCatch>
          {!isFocusEnv() && notifyStatus !== "granted" && (
            <div
              className={classNames("notify-area", {
                "hidden-notify": !notifyDis
              })}
            >
              <img src={changeEgovUrl(notifyInfo)} className="notify-info-logo" />
              {notifyStatus === "denied" ? (
                <span className="help-info">当前无法接收{APP_NAME}消息提醒</span>
              ) : (
                <span className="open-notify">
                  开启通知功能可及时接收{APP_NAME}消息提醒，
                  <a href="#" onClick={openNotify} className="link-notify">
                    开启消息通知
                  </a>
                </span>
              )}
              <img
                src={changeEgovUrl(closeImg)}
                className="close-img"
                onClick={() => {
                  setGlobalContext({
                    ...globalContext,
                    notifyDis: false
                  });
                  setNotifyDis(false);
                }}
              />
            </div>
          )}
          {!isFocusEnv() &&
            getBrowserName !== "chrome" &&
            notifyStatus === "granted" &&
            !browserNotifyTag && (
              <div
                className={classNames("notify-area", {
                  "hidden-notify": !notifyDis
                })}
              >
                <img src={changeEgovUrl(notifyInfo)} className="notify-info-logo" />
                <span className="help-info">
                  您当前使用的浏览器可能无法正常使用{APP_NAME}，建议您使用
                  <a className="link-notify" href="https://browser.360.cn/se/" target="_blank">
                    360浏览器
                  </a>
                </span>
                <img
                  src={changeEgovUrl(closeImg)}
                  className="close-img"
                  onClick={() => {
                    Cookies.set("openBrowserMsgNotify", "true", {
                      expires: 365
                    });
                    setGlobalContext({
                      ...globalContext,
                      notifyDis: false
                    });
                    setNotifyDis(false);
                  }}
                />
              </div>
            )}
          {pageComp}
          <LoginModal />
        </ErrorCatch>
      </GlobalContext.Provider>
      <ThemeComp />
      <NotifyModal visible={notifyVisible} closeMask={() => setNotifyVisible(false)} />
    </Suspense>
  );
}

function mapStateToProps({
  chat,
  user,
  ebook,
  netStatus
}: {
  chat: ChatState;
  user: UserState;
  ebook: EbookState;
  netStatus: NetState;
}) {
  return {
    connectState: chat.connectState.state,
    userData: user.userData,
    currentEmployee: chat.currentEmployee || {},
    selectUserList: ebook.bigScreen?.selectedList || [],
    newContactsCount: ebook.newContactsCount,
    quickReplyVersion: chat.quickReplyVersion,
    loadAllSessionListEnd: chat.loadAllSessionListEnd,
    newPublicResult: netStatus.newPublicResult,
    logActive: user.logActive,
    allSessionList: chat.allSessionList,
    teamConfig: user.teamConfig
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    changePersonalTaskDraw: (taskId: string, visible: boolean, chat?: boolean) =>
      dispatch({
        type: "work/changePersonalTaskDraw",
        payload: { taskId, drawVisible: visible, chat }
      }),
    getCurrentEmployee: (payload: any) => {
      dispatch({ type: "chat/getCurrentEmployee", payload });
    },
    setCurrentNetInfo: (payload: any) => {
      dispatch({ type: "netStatus/setCurrentNetInfo", payload });
    },
    getAllChatSessions: () => {
      dispatch({ type: "chat/getAllChatSessions", payload: {} });
    },
    getNewContactsCount(payload: {}) {
      return dispatch({ type: "ebook/getNewContactsCount", payload });
    },
    setUserData: (payload: any) => {
      dispatch({
        type: "user/setUserData",
        payload
      });
    },
    setCommonConfig: (payload: ICommonConfig) => {
      dispatch({
        type: "user/setCommonConfig",
        payload
      });
    },
    receiveSessionNewMessage: (message: any) => {
      dispatch({
        type: "chat/receiveSessionNewMessage",
        payload: { chatMessage: message }
      });
    },
    receiveCustomAppConfigMessage: (message: any) => {
      dispatch({
        type: "chat/receiveCustomAppConfigMessage",
        payload: { chatMessage: message }
      });
    },
    receiveSessionBatchMessage: (messages: any) => {
      dispatch({
        type: "chat/receiveSessionBatchMessage",
        payload: { chatMessages: messages }
      });
    },
    setDetailDrawerVisible: (visible: boolean, superviseId: string) => {
      dispatch({
        type: "supervise/setDetailDrawerVisible",
        payload: {
          visible,
          superviseId,
          globalSuperviseType: SuperviseType.Receive
        }
      });
    },
    setMainWinShow: (data: { show: boolean }) => {
      dispatch({ type: "chat/setMainWinShow", payload: data });
    },
    clearSessionStatusMap: (data: { show: boolean }) => {
      dispatch({ type: "chat/clearSessionStatusMap", payload: data });
    },
    // 联系人
    updateBigScreenSelectedList(data: any) {
      dispatch({ type: "ebook/updateBigScreenSelectedList", payload: data });
    },
    setRightDrawerVisible(data: any) {
      dispatch({ type: "ebook/setRightDrawerVisible", payload: data });
    },
    setIsMessageModule(payload: boolean) {
      dispatch({ type: "chat/setIsMessageModule", payload });
    },
    setQuickReplyInfo(payload: { quickReplyVersion: number; quickReplys: QuickReply[] }) {
      dispatch({ type: "chat/setQuickReplyInfo", payload });
    },
    updateSessionMessageMid(data: { sendResult: any; sessionId: string }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    },
    updateSessionMessagesTimestamp(data: { timestamp: number }) {
      dispatch({ type: "chat/updateSessionMessagesTimestamp", payload: data });
    },
    updateFollowUserList(data: EmployeeAttribute[]) {
      dispatch({ type: "ebook/updateFollowUserList", payload: data });
    },
    updateGlobalClientConfig(data: any) {
      dispatch({ type: "user/updateGlobalClientConfig", payload: data });
    },
    setPromptData(data: any) {
      dispatch({ type: "user/setPromptData", payload: data });
    },
    updateCustomAppList: (payload: any) => {
      dispatch({ type: "chat/updateCustomAppList", payload });
    },
    updatehirdAppList: (payload: any) => {
      dispatch({ type: "thirdapp/updatehirdAppList", payload });
    },
    setThirdAppMsg: (payload: any) => {
      dispatch({ type: "thirdapp/setThirdAppMsg", payload });
    },
    getCustomNoticeSession: (payload: any) => {
      dispatch({ type: "chat/getCustomNoticeSession", payload });
    },
    setLogActive(data: any) {
      dispatch({ type: "user/setLogActive", payload: data });
    },
    deleteSessionMessages(data: any) {
      dispatch({ type: "chat/deleteSessionMessages", payload: data });
    },
    queryTeamConfig(data: any) {
      dispatch({ type: "user/queryTeamConfig", payload: data });
    },
    fetchAllAppList(data: any) {
      dispatch({ type: "thirdapp/fetchAllAppList", payload: data });
    },
    fetchSceneAppList(data: any) {
      dispatch({ type: "thirdapp/fetchSceneAppList", payload: data });
    },
    loadLocalConfig() {
      dispatch({ type: "user/loadLocalConfig", payload: {} });
    },
    queryFuncInfoData(data: any) {
      dispatch({ type: "user/queryFuncInfoData", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
